/**
 * @Author: v_jppjpeng
 * @Date: 2023-08-17 10:51:38
 * @Explain: 偏好设置
 */

export default {
  'PREFERENCE.MANAGE.OPTIONS.SETTINGS': '选项设置',
  'PREFERENCE.MANAGE.OPTIONS.SETTINGS.TIPS':
    '设置选项，让用户选择他们感兴趣的内容。',
  'PREFERENCE.MANAGE.HOW.TO.USE': '偏好如何使用',
  'PREFERENCE.MANAGE.HOW.TO.USE.TIPS1':
    '偏好选项可让您按兴趣和偏好等对订阅者进行分类。',
  'PREFERENCE.MANAGE.HOW.TO.USE.TIPS2':
    '订阅者可以为自己选择偏好选项，你也可以在 SmartLink 中将订阅者归入偏好选项。',
  'PREFERENCE.MANAGE.MAIL.TEMPLATE': '邮件模板',
  'PREFERENCE.MANAGE.MAIL.TEMPLATE.TIPS':
    '在邮件模板中添加偏好链接，这样订阅者就可以选择他们的偏好。也可以直接导入特定偏好的联系人。',
  'PREFERENCE.MANAGE.SEGMENTS.RULE': '分层规则',
  'PREFERENCE.MANAGE.SEGMENTS.RULE.TIPS':
    '使用分层功能，向特定偏好的联系人发送目标活动。',
  'PREFERENCE.MANAGE.CREATE.OPTIONS': '创建选项',
  'PREFERENCE.MANAGE.CREATE.OPTIONS.FIRST': '先创建选项',
  'PREFERENCE.MANAGE.OPTIONS.NAME': '名称',
  'PREFERENCE.MANAGE.OPTIONS.NAME.REPETITION': '名称已重复',
  'PREFERENCE.MANAGE.OPTIONS.NAME.PLACEHOLDER': '请输入选项名称',
  'PREFERENCE.MANAGE.OPTIONS.NAME.NOT.EMPTY': '名称不可为空',
  'PREFERENCE.MANAGE.OPTIONS.DESC': '简介',
  'PREFERENCE.MANAGE.OPTIONS.DESC.PLACEHOLDER': '请输入简介',
  'PREFERENCE.MANAGE.OPTIONS.DESC.NOT.EMPTY': '简介不可为空',
  'PREFERENCE.MANAGE.IS.SAVE.TITLE': '是否保存修改内容？',
  'PREFERENCE.MANAGE.IS.SAVE.DESC': '刚刚编辑的内容尚未保存，是否保存？',
  'PREFERENCE.MANAGE.IS.DEL.TITLE': '确定删除偏好选项?',
  'PREFERENCE.MANAGE.IS.DEL.DESC':
    '删除 <b class="color-333">{name}</b> 后，偏好选项信息不可恢复。用户在更新偏好选项时将不再显示此信息。',
};
